<script>
	import Catalog from './Catalog.svelte';
	import { lang } from '$lib/translations/menu';
	import { page } from '$app/stores';
	let hoverActive = false;
	let OpenCatalog = false;
</script>

<li
	class="relative"
	on:mouseenter={() => {
		hoverActive = true;
	}}
	on:mouseleave={() => {
		hoverActive = false;
	}}
>
	<div>
		<button
			on:click={() => {
				OpenCatalog = true;
			}}
			class="text-[10px] inline-flex items-center relative md:mr-[15px] lg:mr-[35px] xl:mr-[65px] font-bold text-custom-white-bg"
		>
			{#if hoverActive}
				<div class="border-[#FFFFFF] border-t-[3px] absolute -top-4 h-[3px] left-0 w-full" />
			{/if}
			<svg width="27" height="7" viewBox="0 0 27 7" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect width="27" height="2" fill="white" />
				<rect y="5" width="20" height="2" fill="white" />
			</svg>
			<span class="ml-[13px]"> {lang[$page.data.host]['catalogTitile']}</span>
		</button>
	</div>
</li>

{#if OpenCatalog}
	<Catalog bind:OpenCatalog />
{/if}
